import api from "../../api/axios.config"
import { setClients } from "../slices/clients/clientsSlice";

export const getClients = (id) => {
    return async (dispatch, getState) => {
        const result = await api.get(`api/users`);
        dispatch(setClients(result.data.data));
    }
}